import React, { useState } from "react";
import "bootstrap/js/dist/collapse";
import { useNavigate } from "react-router-dom";

import { formateDate } from "utils/timeFormatter";
import { COPIED_ICON, EXPAND } from "src/constants/images";
import { WALLET } from "src/constants/routes";

const NamingHistory = ({ data }) => {
  const [collapse, setCollapse] = useState(false);
  const [alert, setAlert] = useState(false);
  const copiedData = [...data];
  const history = useNavigate();
  const [isCopied, setIsCopied] = useState(false);

  const handleRedirection = (address) => {
    navigate(WALLET.addSlug(WALLET.INDEX, address));
  };
  const handleCopied = (item) => {
    setIsCopied(!isCopied);
    navigator.clipboard.writeText(`0x${item}`);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  };
  return (
    <div className="transaction-history ">
      <div className="title">Naming History</div>
      <div className="card" style={{ border: "none !important" }}>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Changed By</th> <th scope="col">Date</th>{" "}
              <th scope="col">TxHash</th>
            </tr>
          </thead>
          <tbody className={!data?.length && "empty"}>
            {data?.length ? (
              copiedData?.reverse()?.map((item, index) => (
                <tr key={index}>
                  <td className="item">{item.name}</td>
                  <td
                    className={`to    ${copiedData.length - 1 == index ? "" : "cursor-pointer"
                      }`}
                    onClick={() => {
                      if (copiedData.length - 1 != index)
                        handleRedirection(item.origin);
                    }}
                  >
                    {copiedData.length - 1 == index
                      ? "Auto generated"
                      : `${item.origin.slice(0, 15)}...`}
                  </td>
                  <td className="date-bottom">
                    {formateDate(item.block_height)}
                  </td>
                  <td className=" to">
                    ...{item.tx_hash.substr(58)}
                    <span
                      className="btn p-0 ms-1 "
                      onClick={() => handleCopied(item.tx_hash)}
                    >
                      <img
                        src={COPIED_ICON.SOURCE}
                        alt="copied-item"
                        className="mb-1"
                      />
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <div className="no-transaction">
                <img
                  src={EMPTY_TABLE.SOURCE}
                  alt="no transaction history"
                  className="mb-1"
                />
                <p style={{ color: "var(--light-black)" }}>
                  No Transaction(s) yet
                </p>
              </div>
            )}
          </tbody>
        </table>
      </div>
      {alert && (
        <div
          class="alert alert-primary alert-dismissible fade show px-5"
          role="alert"
        >
          Transaction Hash Copied!
        </div>
      )}
    </div>
    // <div className="naming-history">
    //   <span
    //     className="title"
    //     data-bs-toggle="collapse"
    //     href="#name"
    //     role="button"
    //     aria-expanded="false"
    //     aria-controls="type"
    //     onClick={() => setCollapse((val) => !val)}
    //   >
    //     Naming History
    //   </span>
    //   <div className="card py-3 mt-3 px-3">
    //     <p
    //       className="name d-flex justify-content-between"
    //       data-bs-toggle="collapse"
    //       href="#name"
    //       role="button"
    //       aria-expanded="false"
    //       aria-controls="type"
    //       onClick={() => setCollapse((val) => !val)}
    //     >
    //       {collapse && <span>Press here or naming history to view. </span>}
    //       <img
    //         src={EXPAND.SOURCE}
    //         alt="expand"
    //         className="text-end d-flex ms-auto"
    //       />
    //     </p>
    //     <div className="collapse show" id="name">
    //       {data?.length ? (
    //         copiedData.reverse().map((item, index) => {
    //           return (
    //             <div className="d-flex flex-column flex-md-row" key={index}>
    //               <NamingTime
    //                 date={formateDate(item.block_height)}
    //                 name={item.name}
    //                 tx={item.tx_hash}
    //                 onClick={() => {
    //                   setAlert(true);
    //                   setTimeout(() => {
    //                     setAlert(false);
    //                   }, 3000);
    //                 }}
    //               />
    //               <div className="id d-flex flex-column justify-content-center flex-wrap flex-md-nowrap py-1 my-1 px-1">
    //                 {index === copiedData.length - 1 ? (
    //                   "Auto generated"
    //                 ) : (
    //                   <>
    //                     <div>Changed by </div>

    //                     <div
    //                       tabIndex={0}
    //                       onClick={() => handleRedirection(item.origin)}
    //                       className="text-primary address col-12 text-truncate"
    //                     >
    //                       {item.origin}
    //                     </div>
    //                   </>
    //                 )}
    //               </div>
    //             </div>
    //           );
    //         })
    //       ) : (
    //         <p className="no-tranaction">Name haven't changed yet</p>
    //       )}
    //     </div>
    //   </div>
    //   {alert && (
    //     <div
    //       class="alert alert-primary alert-dismissible fade show px-5"
    //       role="alert"
    //     >
    //       Transaction Hash Copied!
    //     </div>
    //   )}
    // </div>
  );
};

export default NamingHistory;
